import { i18n as fundamentalI18nInstance } from "@hm/fundamental"
import {
	DEFAULT_APP_LANGUAGE,
	defaultNS,
	enabledLanguages,
} from "@shared/i18n/constants"
import i18next from "i18next"
import { initReactI18next } from "react-i18next"

import { resources } from "./translations"

i18next.use(initReactI18next).init({
	resources,
	lng: DEFAULT_APP_LANGUAGE,
	fallbackLng: DEFAULT_APP_LANGUAGE,
	supportedLngs: enabledLanguages,
	defaultNS,
	interpolation: {
		escapeValue: false, // react already safes from xss
	},
	react: {
		useSuspense: true,
	},
})

i18next.on("languageChanged", lang => {
	fundamentalI18nInstance.changeLanguage(lang)
})

export default i18next

export {
	DEFAULT_APP_LANGUAGE,
	defaultNS,
	enabledLanguages,
	supportedLanguages,
} from "@shared/i18n/constants"
export type { SupportedLanguages } from "@shared/i18n/constants"
